import React from "react";
import styled from "styled-components";
import _, { isEqual } from "lodash";
import { connect } from "react-redux";
import numeral from "numeral";

import Button from "@material-ui/core/Button";
import Slider from "react-slick";
// import ReactExport from 'react-export-excel';
import ReactHTMLTableToExcel from "react-html-table-to-excel";
// import $ from 'jquery';

import { H3, H5, H6 } from "../../components/Typography";
import * as Color from "../../components/Color";
import { getRoomDataForRender } from "../../utils/stat-utils";

import { allClass } from "./variables";

import { calColor, setFormatForFillBgColor, formatPrice } from "./functions";

import {
  ImageCoverFix,
  ImageCover,
  BoxProject,
  BoxDistanceBtsMrt,
  BoxFloor,
  BoxTotalUnits,
  BoxParkingLot,
  BoxLaunchYear,
  BoxCompletedYear,
  BoxPackagePrice,
  BoxPriceSqm,
  BoxResalePrice,
  BoxSlodAdmin,
  BoxUnitsLeftAdmin,
  BoxFuniture,
  BoxUnitType,
  BoxCeilling,
  BoxFacility,
  BoxSlinkingFund,
  BoxCommonFee,
  PageBreak,
} from "./styled";

import { tableListData } from "./tableData";
import { checkRole } from "../../utils/checkRole";

const settings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: true,
  swipe: false,
  // prevArrow: <img class='a-left control-c prev slick-prev' src='https://pngimage.net/wp-content/uploads/2018/06/prev-png-4.png' />,
  // nextArrow: <img class='a-right control-c next slick-next' src='https://img.icons8.com/carbon-copy/2x/circled-right-2.png' />,
  responsive: [
    {
      breakpoint: 1919,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1000,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 89%;
  /* padding-left: 100px;
  padding-right: 100px; */
  -webkit-print-color-adjust: exact;
`;

const TitleHolder = styled.div`
  text-align: center;
  margin-bottom: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  display: block;
`;

const TitleText = styled(H3)`
  color: ${Color.primary} !important;
  font-size: 1.25rem !important;
`;

const CompareHolder = styled.div`
  /* width: 100%;
  height: auto;
  background-color: #ffffff;
  display: flex;
  flex-direction: row; */

  width: auto;
  height: 100%;
  display: flex;
  flex-direction: row;
  background-color: #ffffff;
`;
const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;
const H6Text = styled(H6)`
  margin: 0 !important;
`;
const ExportButton = styled(ReactHTMLTableToExcel)`
  color: #fff;
  background-color: rgb(32, 168, 232);
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12);
  padding: 7px 16px 6px;
  font-size: 0.875rem;
  min-width: 64px;
  box-sizing: border-box;
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  min-height: 32px;
  line-height: 1.75;
  font-weight: 500;
  font-family: SukhumvitSet-Medium;
  border-radius: 4px;
  text-transform: uppercase;
  border: 0;
  margin: 0;
  cursor: pointer;
  display: inline-flex;
  outline: none;
  position: relative;
  align-items: center;
  user-select: none;
  vertical-align: middle;
  justify-content: center;
  text-decoration: none;
  margin-right: 10px;
  /* &:hover {
    background-color: #d5d5d5;
  } */
  &:active {
    box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2),
      0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  }
`;

const tableHeaderStyle = {
  fontSize: 14,
  textAlign: "left",
  fontWeight: "bold",
};

const Title = ({ selectedList }) => {
  //  const text = _.map(selectedList, 'title').join('/');
  return (
    <TitleHolder>
      <Button
        disabled
        variant="contained"
        style={{ backgroundColor: "#fafafa" }}
        className="noprint"
      />
      <TitleText>Compare Average</TitleText>
      <H5>
        All the differrnces have been highlighted, making it easy for you to
        pick the best suits your needs!
      </H5>
    </TitleHolder>
  );
};

// const ExcelFile = ReactExport.ExcelFile;
// const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
// const ExcelRow = ReactExport.ExcelFile.ExcelRow;
const checkEmptyFn = (value) => {
  const check =
    _.isUndefined(value) ||
    _.isEqual(value, "") ||
    _.isEqual(value, "0") ||
    _.isEqual(value, "0.00") ||
    _.isEqual(value, 0);
  return check ? "N/A" : value;
};

const mapStateToProps = (state, ownProps) => {
  const paramsIds = _.get(ownProps, "match.params.ids");
  // const paramsIds = 'BL26.S2.green-point-silom,S3.ascott-sky-villa-sathorn-9,S3.ashton-silom,S3.diamond-tower,S3.ivy-sathorn-10';
  const poi = _.get(ownProps, "match.params.poi");
  const entitiesProject = _.get(state, "entities.projects.entities");
  const entitiesPoint = _.get(state, "entities.pointOfInterests.entities");
  const ids = _.split(paramsIds, ",");
  const compareData = _.pick(entitiesProject, ids);
  const pointInterest = _.pick(entitiesPoint, poi);
  const userRoles = _.get(state, "domain.user.user.roles");
  // console.log('pointInterest', entitiesPoint, pointInterest, poi);
  // console.log('compareData>>>> ', compareData)
  return {
    compareData,
    pointInterest,
    poi,
    userRoles,
  };
};

const projects = [{}, {}, {}, {}, {}];

const setHeightOfRow = () => {
  var style = document.createElement("style");
  document.head.appendChild(style);

  _.map(allClass, (item) => {
    const contentElement = document.getElementsByClassName(
      `${item.contentClass}`
    );
    // const titleElement = document.getElementsByClassName(item.titleClass);

    // var result = $(`.${item.contentClass}`).outerHeight();
    // var result = $(`.${item.txtClass}`);
    // $.each(result, function() {
    //   console.log('>>>>', $(this).height());
    // });
    // console.log(`${item.contentClass} result >>> `, result)

    // console.log(`${item.contentClass} contentElement>>> `, contentElement)

    const heightList = _.map(contentElement, (items, i) => {
      // console.log(`${item.contentClass} items>>> `, items.children)
      // console.log(`map ${item.contentClass} ${i} `, items.offsetHeight, items.clientHeight, items)
      return items.offsetHeight;
    });

    // console.log(`heightList >>>> `, heightList)

    style.sheet.insertRule(
      `.${item.titleClass}, .${item.contentClass} {height: ${_.max(
        heightList
      )}px}`
    );
  });
};

export default connect(mapStateToProps)(
  class extends React.Component {
    state = {
      containerOverflow: "auto",
      showSlider: true,
      compareDataExcel: { columns: [], data: [] },
    };

    componentDidMount() {
      setHeightOfRow();

      window.onafterprint = () => {
        window.location.reload();
        // this.setState(
        //   {
        //     containerOverflow: 'auto',
        //     showSlider: true,
        //   },
        //   () => {
        //     console.log('finish');
        //   }
        // );
      };
    }

    addAvgData = (projects) => {
      let newProjects = {};
      _.map(projects, (project) => {
        const avgRoomData = getRoomDataForRender(_.get(project, "rooms"), [
          { key: "startingPrice", mode: "min" },
          { key: "startingResalePrice", mode: "min" },
          { key: "resalePriceSqm", mode: "avg" },
          { key: "rentalPriceSqm", mode: "avg" },
          { key: "totalUnits", mode: "sum" },
          { key: "soldUnits", mode: "sum" },
          { key: "unitsLeft", mode: "sum" },
          { key: "percentSold", mode: "avg" },
          { key: "rentalYield", mode: "avg" },
          { key: "capitalGain", mode: "avg" },
        ]);
        // console.log("avgRoomData??", avgRoomData);
        newProjects = {
          ...newProjects,
          [_.get(project, "code")]: {
            ...project,
            startingPrice: _.get(avgRoomData, "startingPrice"),
            startingResalePrice: _.get(avgRoomData, "startingResalePrice"),
            resalePriceSqm: _.get(avgRoomData, "resalePriceSqm"),
            rentalPriceSqm: _.get(avgRoomData, "rentalPriceSqm"),
            totalUnits: _.get(avgRoomData, "totalUnits"),
            soldUnits: _.get(avgRoomData, "soldUnits"),
            unitsLeft: _.get(avgRoomData, "unitsLeft"),
            percentSold: _.get(avgRoomData, "percentSold"),
            rentalYield: _.get(avgRoomData, "rentalYield"),
            capitalGain: _.get(avgRoomData, "capitalGain"),
          },
        };
        // console.log("newProjects??", newProjects);
      });
      return newProjects;
    };

    renderProjectCard = (projects, showSlider) => {
      const isRoleGeneral = checkRole(
        this.props.userRoles,
        "mi-treasure.general-member"
      );
      const WrapDetailProject = styled.div`
        width: 250px;
        display: ${this.state.showSlider ? "" : "inline-block"};
        @media only screen and (max-width: 767px) {
          width: 200px;
          height: auto;
        }
        @media only screen and (max-width: 320px) {
          width: 210px;
          height: auto;
          padding-right: 25px;
        }
      `;
      const newProjects = this.addAvgData(projects);
      const projectToArr = _.toArray(newProjects);
      // console.log('projectToArr>>> ', projectToArr)
      const countProjects = _.size(projectToArr);
      const xxx = setFormatForFillBgColor(projectToArr);
      // console.log('p>> xxx ', xxx);
      const minProjectArr = _.get(xxx, "min");
      const maxProjectArr = _.get(xxx, "max");
      const setColorBg = (field, projId) => {
        // console.log(`setColorBg ${field} | ${projId}>>>> `, minProjectArr, maxProjectArr, countProjects)
        return calColor(
          field,
          minProjectArr,
          maxProjectArr,
          projId,
          countProjects
        );
      };
      const projectCards = _.map(newProjects, (p, key) => {
        const index = _.get(p, 'id');
        return (
          <React.Fragment>
            {/* {!showSlider && index == 0 && this.renderTitleColumn()} */}
            <WrapDetailProject>
              <ImageCover
                src={_.get(p, 'coverImageUrl') || "https://www.forfur.com/img/I53/l_5240_14490368061827038696.jpg"}
                alt="img1"
              />
              <BoxProject className="box-project">
                <H6Text className="txt-project">
                  {_.startCase(_.lowerCase(_.get(p, "title.en")))}
                </H6Text>
                {/* <H6Text>MAHANAKORN CONDOMINIUMM</H6Text> */}
              </BoxProject>
              {/* bgColor={calColor('distanceFromBts', minProjectArr, maxProjectArr, index, countProjects)} */}
              <BoxDistanceBtsMrt
                className="box-distance-bts-mrt"
                bgColor={setColorBg("distanceFromBts", index)}
              >
                <H6Text className="txt-distance-bts-mrt">{`${_.get(
                  p,
                  "distanceFromBts",
                  "-"
                )} m from ${_.get(p, "station.name", "-")}`}</H6Text>
              </BoxDistanceBtsMrt>
              {isRoleGeneral && (
                <BoxProject className="box-station">
                  <H6Text className="txt-station">{`${_.get(
                    p,
                    "station.name",
                    "-"
                  )}`}</H6Text>
                </BoxProject>
              )}
              <BoxProject className="box-developer">
                <H6Text>{_.get(p, "developer", "N/A")}</H6Text>
              </BoxProject>
              <BoxProject className="box-project-type">
                <H6Text>{_.get(p, "projectType", "N/A")}</H6Text>
              </BoxProject>
              {!isRoleGeneral && (
                <BoxProject className="box-construction">
                  <H6Text>{_.get(p, "constructionStatus", "N/A")}</H6Text>
                </BoxProject>
              )}
              <BoxFloor className="box-floor">
                <H6Text className="txt-floor">
                  {checkEmptyFn(_.get(p, "floor"))}
                </H6Text>
              </BoxFloor>
              <BoxTotalUnits
                className="box-total-units"
                bgColor={setColorBg("totalUnits", index)}
              >
                <H6Text className="txt-total-units">
                  {checkEmptyFn(_.get(p, "totalUnits"))}
                </H6Text>
              </BoxTotalUnits>
              <BoxParkingLot
                className="box-parking-lot"
                bgColor={setColorBg("parkingLot", index)}
              >
                <H6Text className="txt-parking-lot">
                  {checkEmptyFn(_.get(p, "parkingLot", ""))}%
                </H6Text>
              </BoxParkingLot>
              <BoxLaunchYear
                className="box-launch-year"
                bgColor={setColorBg("yearLaunch", index)}
              >
                <H6Text className="txt-launch-year">
                  Launch: {checkEmptyFn(_.get(p, "yearLaunch", "-"))}
                </H6Text>
              </BoxLaunchYear>
              <BoxCompletedYear
                className="box-completed-year"
                bgColor={setColorBg("yearComplete", index)}
              >
                <H6Text className="txt-completed-year">
                  Complete: {checkEmptyFn(_.get(p, "yearComplete", "-"))}
                </H6Text>
              </BoxCompletedYear>
              {!isRoleGeneral && (
                <BoxPackagePrice className="box-package-price">
                  <H6Text className="txt-package-price">
                    Launch Price ={" "}
                    {_.toUpper(
                      checkEmptyFn(
                        numeral(_.get(p, "launchPriceSqm")).format("0,0.00a")
                      )
                    )}{" "}
                    sq.m.
                  </H6Text>
                  <H6Text className="txt-package-price">
                    Current Price ={" "}
                    {_.toUpper(
                      checkEmptyFn(
                        numeral(_.get(p, "currentPriceSqm")).format("0,0.00a")
                      )
                    )}{" "}
                    sq.m.
                  </H6Text>
                </BoxPackagePrice>
              )}
              {!isRoleGeneral && (
                <BoxPriceSqm className="box-price-sqm">
                  <H6Text className="txt-price-sqm">
                    Launch Price ={" "}
                    {_.toUpper(
                      checkEmptyFn(
                        numeral(_.get(p, "launchPriceSqm")).format("0,0.00a")
                      )
                    )}{" "}
                    sq.m.
                  </H6Text>
                  <H6Text className="txt-price-sqm">
                    Current Price ={" "}
                    {_.toUpper(
                      checkEmptyFn(
                        numeral(_.get(p, "currentPriceSqm")).format("0,0.00a")
                      )
                    )}{" "}
                    sq.m.
                  </H6Text>
                  {/* <ul style={{ margin: 0, paddingLeft: 20 }}>
                    <li>
                      <H6Text>1 BR: 30-31.5 sq.m. (225 units, 22%)</H6Text>
                    </li>
                    <li>
                      <H6Text>2 BR: 52 sq.m. (2 units, 1%)</H6Text>
                    </li>
                  </ul> */}
                </BoxPriceSqm>
              )}
              <BoxResalePrice
                className="box-resale-price"
                bgColor={setColorBg("resalePriceSqm", index)}
              >
                <H6Text className="txt-resale-price">
                  {_.toUpper(
                    checkEmptyFn(
                      numeral(_.get(p, "resalePriceSqm")).format("0,0.00a")
                    )
                  )}
                </H6Text>
                {/* <ul style={{ margin: 0, paddingLeft: 20 }}>
                  <li>
                    <H6Text>
                      1 BR: 30-31.5 sq.m.: THB 7.68 million (192 units left)
                    </H6Text>
                  </li>
                  <li>
                    <H6Text>
                      2 BR: 52 sq.m.: THB 13.3 million (1 units left)
                    </H6Text>
                  </li>
                </ul> */}
              </BoxResalePrice>

              {isRoleGeneral && (
                <BoxResalePrice className="box-resale-package">
                  <H6Text className="txt-resale-package">
                    {_.toUpper(
                      checkEmptyFn(
                        numeral(_.get(p, "startingPrice")).format("0,0.00a")
                      )
                    )}
                  </H6Text>
                </BoxResalePrice>
              )}
              {isRoleGeneral && (
                <BoxResalePrice className="box-rental-package">
                  <H6Text className="txt-rental-package">
                    {_.toUpper(
                      checkEmptyFn(
                        numeral(_.get(p, "rentalPrice")).format("0,0.00a")
                      )
                    )}
                  </H6Text>
                </BoxResalePrice>
              )}
              {isRoleGeneral && (
                <BoxResalePrice className="box-rental-price">
                  <H6Text className="txt-rental-price">
                    {_.toUpper(
                      checkEmptyFn(
                        numeral(_.get(p, "rentalPriceSqm")).format("0,0.00a")
                      )
                    )}
                  </H6Text>
                </BoxResalePrice>
              )}

              {_.includes(this.props.userRoles, "mi-treasure.admin") && (
                <BoxSlodAdmin
                  className="box-slod-admin"
                  bgColor={setColorBg("percentSold", index)}
                >
                  <H6Text className="txt-slod-admin">
                    {checkEmptyFn(_.get(p, "percentSold", "-"))}
                  </H6Text>
                </BoxSlodAdmin>
              )}
              {_.includes(this.props.userRoles, "mi-treasure.admin") && (
                <BoxUnitsLeftAdmin
                  className="box-units-left-admin"
                  bgColor={setColorBg("unitsLeft", index)}
                >
                  <H6Text className="txt-units-left-admin">
                    {checkEmptyFn(_.get(p, "unitsLeft", "-"))}
                  </H6Text>
                </BoxUnitsLeftAdmin>
              )}
              <BoxFuniture className="box-funiture">
                <H6Text className="txt-funiture">
                  {checkEmptyFn(_.get(p, "furniturePackage", "-"))}
                </H6Text>
                {/* <ul style={{ margin: 0, paddingLeft: 20 }}>
                  <li>
                    <H6Text>mock 1</H6Text>
                  </li>
                  <li>
                    <H6Text>mock 2</H6Text>
                  </li>
                </ul> */}
              </BoxFuniture>
              {!isRoleGeneral && (
                <BoxUnitType className="box-unittype">
                  <H6Text className="txt-unittype">
                    {_.get(p, "unitsType", "-")}
                  </H6Text>
                </BoxUnitType>
              )}
              <BoxCeilling
                className="box-ceilling"
                bgColor={setColorBg("ceiling", index)}
              >
                <H6Text className="txt-ceilling">
                  {checkEmptyFn(_.get(p, "ceiling", "-"))}
                </H6Text>
              </BoxCeilling>
              {!isRoleGeneral && (
                <BoxFacility className="box-facility">
                  <H6Text className="txt-facility">
                    {_.get(p, "facility", "-")}
                  </H6Text>
                </BoxFacility>
              )}
              <BoxSlinkingFund
                className="box-slinking-fund"
                bgColor={setColorBg("sinkingFund", index)}
              >
                <H6Text className="txt-slinking-fund">
                  {checkEmptyFn(_.get(p, "sinkingFund", "-"))}
                </H6Text>
              </BoxSlinkingFund>
              <BoxCommonFee
                className="box-common-fee"
                bgColor={setColorBg("commonFee", index)}
              >
                <H6Text className="txt-common-fee">
                  {checkEmptyFn(_.get(p, "commonFee", "-"))}
                </H6Text>
              </BoxCommonFee>
            </WrapDetailProject>
            {!showSlider && index == 2 && <PageBreak />}
          </React.Fragment>
        );
      });
      return projectCards;
    };

    renderTitleColumn = () => {
      const isRoleGeneral = checkRole(
        this.props.userRoles,
        "mi-treasure.general-member"
      );
      const SlideWrapper = styled.div`
        width: 250px;
        height: auto;
        display: ${this.state.showSlider ? "" : "inline-block"};

        @media only screen and (max-width: 767px) {
          width: 150px;
          height: auto;
          padding-left: 20px;
        }
        @media only screen and (max-width: 320px) {
          width: 140px;
          height: auto;
          padding-left: 10px;
        }
      `;
      return (
        <SlideWrapper>
          <ImageCoverFix />
          <BoxProject textPosition="right" className="title-project">
            <H6Text>Project</H6Text>
          </BoxProject>
          <BoxDistanceBtsMrt
            textPosition="right"
            className="title-distance-bts-mrt"
          >
            <H6Text>Distance from BTS / MRT</H6Text>
          </BoxDistanceBtsMrt>
          {isRoleGeneral && (
            <BoxProject textPosition="right" className="title-station">
              <H6Text>Station</H6Text>
            </BoxProject>
          )}
          <BoxProject textPosition="right" className="title-developer">
            <H6Text>Developer</H6Text>
          </BoxProject>
          <BoxProject textPosition="right" className="title-project-type">
            <H6Text>Project Type</H6Text>
          </BoxProject>
          {!isRoleGeneral && (
            <BoxProject textPosition="right" className="title-construction">
              <H6Text>Construction Status</H6Text>
            </BoxProject>
          )}
          <BoxFloor textPosition="right" className="title-floor">
            <H6Text>Floor</H6Text>
          </BoxFloor>
          <BoxTotalUnits textPosition="right" className="title-total-units">
            <H6Text>Total Units</H6Text>
          </BoxTotalUnits>
          <BoxParkingLot textPosition="right" className="title-parking-lot">
            <H6Text>Parking lot</H6Text>
          </BoxParkingLot>
          <BoxLaunchYear textPosition="right" className="title-launch-year">
            <H6Text>Launch Year</H6Text>
          </BoxLaunchYear>
          <BoxCompletedYear
            textPosition="right"
            className="title-completed-year"
          >
            <H6Text>Completed Year</H6Text>
          </BoxCompletedYear>
          {!isRoleGeneral && (
            <BoxPackagePrice
              textPosition="right"
              className="title-package-price"
            >
              <H6Text>Package Price (Launch/Current)</H6Text>
            </BoxPackagePrice>
          )}
          {!isRoleGeneral && (
            <BoxPriceSqm textPosition="right" className="title-price-sqm">
              <H6Text>Price/Sq.m (Launch/Current)</H6Text>
            </BoxPriceSqm>
          )}
          <BoxResalePrice textPosition="right" className="title-resale-price">
            <H6Text>Avg.Resale Price</H6Text>
          </BoxResalePrice>
          {isRoleGeneral && (
            <BoxResalePrice
              textPosition="right"
              className="title-resale-package"
            >
              <H6Text>Avg.Resale Package</H6Text>
            </BoxResalePrice>
          )}
          {isRoleGeneral && (
            <BoxResalePrice
              textPosition="right"
              className="title-rental-package"
            >
              <H6Text>Avg.Rental Package</H6Text>
            </BoxResalePrice>
          )}
          {isRoleGeneral && (
            <BoxResalePrice textPosition="right" className="title-rental-price">
              <H6Text>Avg.Rental Price</H6Text>
            </BoxResalePrice>
          )}
          {_.includes(this.props.userRoles, "mi-treasure.admin") && (
            <BoxSlodAdmin textPosition="right" className="title-slod-admin">
              <H6Text>% Sold</H6Text>
            </BoxSlodAdmin>
          )}
          {_.includes(this.props.userRoles, "mi-treasure.admin") && (
            <BoxUnitsLeftAdmin
              textPosition="right"
              className="title-units-left-admin"
            >
              <H6Text>Units Left</H6Text>
            </BoxUnitsLeftAdmin>
          )}
          <BoxFuniture textPosition="right" className="title-funiture">
            <H6Text>Funiture Package</H6Text>
          </BoxFuniture>
          {!isRoleGeneral && (
            <BoxUnitType textPosition="right" className="title-unittype">
              <H6Text>Units Type</H6Text>
            </BoxUnitType>
          )}
          <BoxCeilling textPosition="right" className="title-ceilling">
            <H6Text>Ceilling</H6Text>
          </BoxCeilling>
          {!isRoleGeneral && (
            <BoxFacility textPosition="right" className="title-facility">
              <H6Text>Facility</H6Text>
            </BoxFacility>
          )}
          <BoxSlinkingFund textPosition="right" className="title-slinking-fund">
            <H6Text>Slinking Fund</H6Text>
          </BoxSlinkingFund>
          <BoxCommonFee textPosition="right" className="title-common-fee">
            <H6Text>Common Fee</H6Text>
          </BoxCommonFee>
          {/* <PageBreak /> */}
        </SlideWrapper>
      );
    };

    prepareThenPrint = () => {
      this.setState(
        {
          containerOverflow: "visible",
          showSlider: false,
        },
        () => {
          setTimeout(() => {
            window.print();
          }, 1500);
        }
      );
    };

    mapDataTable = (keyName, type) => {
      const projectToArr = _.toArray(this.props.compareData);
      const countProjects = _.size(projectToArr);
      const xxx = setFormatForFillBgColor(projectToArr);
      // console.log('nonggg xxx', xxx);
      const minProjectArr = _.get(xxx, "min");
      const maxProjectArr = _.get(xxx, "max");
      const setColorBg = (field, projId) => {
        return calColor(
          field,
          minProjectArr,
          maxProjectArr,
          projId,
          countProjects
        );
      };
      const headerStyle = { width: 200, fontSize: 14, textAlign: "left" };

      const mapDataParent = _.map(this.props.compareData, (item, index) => {
        const data = _.get(item, keyName) === "" ? "-" : _.get(item, keyName);
        if (type === "launchPrice") {
          return (
            <td key={index} style={headerStyle}>
              Launch Price = {data} sq.m.
            </td>
          );
        } else if (type === "currentPrice") {
          return (
            <td key={index} style={headerStyle}>
              Current Price = {data} sq.m.
            </td>
          );
        } else {
          return (
            <td
              key={index}
              style={{
                width: 200,
                fontSize: 14,
                textAlign: "left",
                backgroundColor: setColorBg(keyName, index),
              }}
            >
              {data}
            </td>
          );
        }
      });
      return mapDataParent;
    };

    mapRow = () => {
      const rowTable = _.map(tableListData, (item, index) => {
        switch (_.get(item, "type")) {
          case "normal":
            return (
              <tr>
                <th style={tableHeaderStyle}>{_.get(item, "text")}</th>
                {this.mapDataTable(_.get(item, "key"))}
              </tr>
            );
          case "admin":
            return (
              // this.props.userRoles === 'admin' && (
              <tr>
                <th style={tableHeaderStyle}>{_.get(item, "text")}</th>
                {this.mapDataTable(_.get(item, "key"))}
              </tr>
              // )
            );
          case "price1":
            return (
              <tr>
                <th rowSpan="2" style={tableHeaderStyle}>
                  {_.get(item, "text")}
                </th>
                {this.mapDataTable(_.get(item, "key"), "launchPrice")}
              </tr>
            );
          case "price2":
            return (
              <tr>{this.mapDataTable(_.get(item, "key"), "currentPrice")}</tr>
            );
          default:
            break;
        }
      });
      return rowTable;
    };

    renderTable = () => {
      return (
        <table id="table-to-xls" style={{ display: "none" }}>
          <tr>
            <th style={{ width: 150, fontSize: 14, textAlign: "left" }}>
              Project
            </th>
            {this.mapDataTable("title.en")}
          </tr>
          {this.mapRow()}
        </table>
      );
    };

    render() {
      const { containerOverflow, showSlider } = this.state;
      const { userRoles } = this.props;

      const isRoleAdmin = checkRole(userRoles, "mi-treasure.admin");
      const isRoleEditor = checkRole(userRoles, "mi-treasure.sale");
      const Container = styled.div`
        padding-top: 20px;
        padding-bottom: 38px;
        background: #fafafa;
        width: 100%;
        height: calc(100vh - 155px);
        display: flex;
        flex-direction: column;
        align-items: center;
        overflow: ${containerOverflow};
      `;
      const AllSlideWrapper = styled.div`
        width: 750px;
        height: auto;
        /* display: block; */
        display: ${showSlider ? "" : "flex"};
        flex-wrap: ${showSlider ? "" : "wrap"};
        @media only screen and (min-width: 1920px) {
          width: 1000px;
          height: auto;
        }
        @media only screen and (max-width: 1000px) {
          width: 500px;
          height: auto;
        }
        @media only screen and (max-width: 767px) {
          width: 250px;
          height: auto;
        }
        @media only screen and (max-width: 320px) {
          width: 210px;
          height: auto;
        }
      `;

      // const { compareData, poi } = this.props;

      return (
        <Container>
          <Content>
            <Title />
            {showSlider ? (
              <CompareHolder>
                {this.renderTitleColumn()}
                <AllSlideWrapper>
                  <Slider {...settings}>
                    {this.renderProjectCard(this.props.compareData, showSlider)}
                  </Slider>
                </AllSlideWrapper>
              </CompareHolder>
            ) : (
              <CompareHolder>
                {this.renderTitleColumn()}
                <AllSlideWrapper>
                  {this.renderProjectCard(this.props.compareData, showSlider)}
                </AllSlideWrapper>
              </CompareHolder>
            )}
            {showSlider && (
              <ButtonWrapper>
                {(isRoleAdmin || isRoleEditor) && (
                  <React.Fragment>
                    <ExportButton
                      id="test-table-xls-button"
                      table="table-to-xls"
                      filename="Compare-Projects"
                      sheet="Compare Projects"
                      buttonText="Export Excel"
                    />
                    {this.renderTable()}
                    <Button
                      variant="contained"
                      color="primary"
                      className="noprint"
                      onClick={() => {
                        this.prepareThenPrint();
                      }}
                    >
                      Export screen
                    </Button>
                  </React.Fragment>
                )}
                <Button
                  variant="contained"
                  className="noprint"
                  style={{
                    backgroundColor: "#20a8e8",
                    marginLeft: 10,
                    color: "#ffffff",
                  }}
                  onClick={() => {
                    const copyText = document.getElementById("full-path");
                    // console.log("copyText", copyText);
                    /* Select the text field */
                    copyText.select();
                    copyText.setSelectionRange(0, 99999); /*For mobile devices*/

                    /* Copy the text inside the text field */
                    document.execCommand("copy");

                    /* Alert the copied text */
                    alert("Url copied");
                  }}
                >
                  Share
                </Button>
              </ButtonWrapper>
            )}
          </Content>
          <input
            style={{ opacity: 0 }}
            type="text"
            value={window.location.href}
            id="full-path"
          ></input>
        </Container>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/screens/CompareProject/index.js